

<ion-content class="ion-page brand-default">
  <div class="background-container">

  <div style="max-width:20em;">
    <a href="/">
      <ion-img id="topmenu-logo" slot="start"
        size="small"
        src="{{ logoImagePath }}"
        alt="Quotify Logo"
        style="width: 200px; margin: 1em 0em 0em 1em;"
      >
      </ion-img>
    </a>
  </div>

  <div>

    <ion-grid style="max-height: 30em;margin-block-start: 5em;">

      <ion-row class="ion-justify-content-center">
        <ion-card>
          <ion-item color="primary" text-center>
            <ion-label class="header">{{resetPasswordViewModel.hasPassword? "Reset Password" : "Set Password"}}</ion-label>
          </ion-item>
          <ion-card-content>

            <form [formGroup]="userResetPasswordForm" (ngSubmit)="onSubmitForm()">

              <ion-list style="width:90vw;max-width: 40em;">
                <ion-item>
                  <ion-input #passwordInputField type="password" id="Password" ngDefaultControl placeholder="Password"
                    formControlName="password" togglePassword>
                    <div slot="label">Password <ion-text color="danger"
                        *ngIf="isRequiredField(userResetPasswordForm,'password')">*</ion-text></div>
                  </ion-input>
                </ion-item>
                <error-messages [control]="userResetPasswordForm.get('password')" [fieldName]="'Password'"></error-messages>

                 <ion-item>
                  <ion-input #reenterpasswordInputField type="password" id="ReenterPassword" ngDefaultControl placeholder="Re-enter Password"
                    formControlName="reenterPassword" togglePassword>
                    <div slot="label">Re-enter Password <ion-text color="danger"
                        *ngIf="isRequiredField(userResetPasswordForm,'reenterPassword')">*</ion-text></div>
                  </ion-input>
                </ion-item>
                <error-messages [control]="userResetPasswordForm.get('reenterPassword')" [fieldName]="'Re-enter Password'"></error-messages>

                 
                    <ion-item lines="none" *ngIf="!resetPasswordViewModel.signedCustomerTermsOfUse">
                      <ion-checkbox
                        style="margin-right: 5px;"
                        formControlName="agreedToCustomerTermsOfUse"
                        ngDefaultControl
                      ></ion-checkbox>
                      <ion-label style="font-size: 13.5px; color: grey">
                        By checking, you agree to Quoteify's
                        <a (click)="onClickTermsOfUse()">Customer Terms of Use</a>
                      </ion-label>
                      
                    </ion-item>
                    <error-messages [control]="userResetPasswordForm.get('agreedToCustomerTermsOfUse')"
                      [fieldName]="'Terms and Conditions Compliance'">
                    </error-messages>
                   
                    <div style="text-align: center; margin-top: 1em;">
                      <ion-button   type="submit" style="width: 200px;" strong="true" size="medium" fill="solid">Continue</ion-button><br>
                      <ion-router-link id ="LoginLink"style=""routerLink="/user/user-login">Back to Login</ion-router-link>                     
                    </div>
                              
                </ion-list>
            </form>
          </ion-card-content>
        </ion-card>
      </ion-row>
    </ion-grid>
  </div>

  </div>
</ion-content>
